<script>
import { ref, watch } from 'vue';
import { limpiarObjeto, puntoDeVenta, guardarPuntoDeVenta, guardandoPuntoDeVenta, desconectar } from '@/../../cliente_comun/fuentes_puntosDeVenta.js'
import PuntoDeVentaUbicacionesListado from './Ubicaciones/PuntoDeVentaUbicacionesListado.vue'
import PuntoDeVentaUbicacionDetalles from './Ubicaciones/PuntoDeVentaUbicacionDetalles.vue';

export default {
	props: {
		datos: Object
	},
	components: {
		PuntoDeVentaUbicacionesListado,
		PuntoDeVentaUbicacionDetalles,
	},
	beforeDestroy() {
		desconectar()
	},
	setup(props, { emit }) {
		const diálogoPuntoDeVentaUbicación = ref(false)
		const ubicaciónSeleccionada = ref(null)
		const identificador = ref(null)
		limpiarObjeto()

		if (props.datos) {
			identificador.value = props.datos.identificador
			puntoDeVenta.nombre = props.datos.nombre
			puntoDeVenta.descripción = props.datos.descripción
			puntoDeVenta.códigoDeAcceso = props.datos.códigoDeAcceso
		}

		watch(() => props.datos, (d) => {
			if (d) {
				identificador.value = d.identificador
				puntoDeVenta.nombre = d.nombre
				puntoDeVenta.descripción = d.descripción
				puntoDeVenta.códigoDeAcceso = d.códigoDeAcceso
			} else {
				identificador.value = null
				limpiarObjeto()
			}
		})

		async function guardarPuntoDeVenta_() {
			try {
				await guardarPuntoDeVenta(identificador.value)
				emit('guardar', true)
			} catch (_) {}
		}

		function abrirEdiciónDeUbicación(U) {
			ubicaciónSeleccionada.value = U
			diálogoPuntoDeVentaUbicación.value = true
		}

		function abrirCreaciónDeUbicación() {
			ubicaciónSeleccionada.value = null
			diálogoPuntoDeVentaUbicación.value = true
		}

		function cerrarDetallesDeUbicación() {
			diálogoPuntoDeVentaUbicación.value = false
			ubicaciónSeleccionada.value = null
		}

		return {
			diálogoPuntoDeVentaUbicación,
			identificador,
			ubicaciónSeleccionada,
			puntoDeVenta,
			guardandoPuntoDeVenta,
			guardarPuntoDeVenta_,
			abrirEdiciónDeUbicación,
			abrirCreaciónDeUbicación,
			cerrarDetallesDeUbicación,
			emit,
		}
	}
}

</script>

<template>
	<div>
		<v-card>
			<v-card-title class="headline">Punto de venta</v-card-title>

			<v-card-text>

				<v-text-field
					v-model="puntoDeVenta.nombre"
					maxlength="100"
					label="Nombre"
					required
				></v-text-field>

				<v-text-field
					v-model="puntoDeVenta.descripción"
					maxlength="500"
					label="Descripción"
				></v-text-field>

				<v-text-field
					v-model="puntoDeVenta.códigoDeAcceso"
					minlength="6"
					maxlength="8"
					label="Código de acceso"
					hint="Código de acceso a punto de venta abierto"
				></v-text-field>

			</v-card-text>

			<div v-if="identificador">
				<h4 class="ml-4">Ubicaciones:</h4>
				<PuntoDeVentaUbicacionesListado
					:identificadorDePuntoDeVenta="identificador"
					@editar="abrirEdiciónDeUbicación($event)"
				></PuntoDeVentaUbicacionesListado>
				<v-btn
					outlined
					color="blue darken-2"
					class="ml-4"
					@click="abrirCreaciónDeUbicación()"
				>
					Agregar ubicación
				</v-btn>
			</div>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					color="grey darken-1"
					text
					:disabled="guardandoPuntoDeVenta"
					@click="emit('cancelar', true)"
				>
					Cancelar
				</v-btn>

				<v-btn
					color="green darken-1"
					text
					:loading="guardandoPuntoDeVenta"
					@click="guardarPuntoDeVenta_"
				>
					Guardar
				</v-btn>
			</v-card-actions>
		</v-card>

		<v-dialog
			v-model="diálogoPuntoDeVentaUbicación"
			max-width="900"
			persistent
		>
			<PuntoDeVentaUbicacionDetalles
				:identificadorDePuntoDeVenta="identificador"
				:datos="ubicaciónSeleccionada"
				@guardar="cerrarDetallesDeUbicación()"
				@cancelar="cerrarDetallesDeUbicación()"
			></PuntoDeVentaUbicacionDetalles>
		</v-dialog>
	</div>
</template>
